"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFullDomainName = exports.validateConfig = exports.BASE_OV_ENVIRONMENTS = exports.OV_ENVIRONMENTS = exports.OV_ENVIRONMENT = void 0;
var OV_ENVIRONMENT;
(function (OV_ENVIRONMENT) {
    OV_ENVIRONMENT["PROD"] = "prod";
    OV_ENVIRONMENT["UAT"] = "uat";
    OV_ENVIRONMENT["DEV"] = "dev";
})(OV_ENVIRONMENT = exports.OV_ENVIRONMENT || (exports.OV_ENVIRONMENT = {}));
exports.OV_ENVIRONMENTS = Object.values(OV_ENVIRONMENT);
exports.BASE_OV_ENVIRONMENTS = [
    OV_ENVIRONMENT.PROD,
    OV_ENVIRONMENT.UAT,
    OV_ENVIRONMENT.DEV,
];
function validateConfig(config) {
    const missingVars = Object.entries(config).reduce((result, [key, value]) => {
        if (!value) {
            result.push(key);
        }
        return result;
    }, []);
    if (missingVars.length) {
        throw new Error(`👉 The next environment variables are missing: ${missingVars.join(', ')}\n`);
    }
    if (!exports.OV_ENVIRONMENTS.includes(config.ENVIRONMENT)) {
        throw new Error(`👉 Environment "${config.ENVIRONMENT}"is invalid. Allowed values: ${exports.OV_ENVIRONMENTS.join(', ')}`);
    }
}
exports.validateConfig = validateConfig;
function getFullDomainName({ domain, subDomain, env, }) {
    const subDomainPart = env === OV_ENVIRONMENT.PROD ? '' : `${env}-`;
    return `${subDomainPart}${subDomain}.${domain}`;
}
exports.getFullDomainName = getFullDomainName;
